'use client'

import { type FC, useEffect } from 'react'

import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { useExperimentsPageType } from '../../../experiments/components/ExperimentsPageTypeContext'
import { adServerGetExperiments } from '../../adServerGetExperiments'

export const AdServerExperimentActivation: FC = () => {
  const pageType = useExperimentsPageType()
  const { addExperimentKeysForActivation, experiments } =
    useExperimentsContext()

  useEffect(() => {
    const featureKeys = adServerGetExperiments(experiments, pageType).map(
      (experiment) => experiment.name,
    )

    if (featureKeys.length > 0) {
      addExperimentKeysForActivation(featureKeys)
    }
  }, [addExperimentKeysForActivation, experiments, pageType])

  return null
}
